






























































import {
  defineComponent,
  PropType,
  ref,
  computed,
  watch,
  nextTick,
} from '@vue/composition-api';
import { Popup, Button } from '@hb/coffee';
import { UpArrowOutline12, DownArrowOutline12 } from '@hb/coffee-icons';
import { getAgreementsByCommodities } from '@/api/contract';
import { ContractEnum } from '@/enums/contract-type';
import type { Contract } from '@/api/contract/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import type { CreditAgreementsReadPopProps } from './types';
import { CreditAgreementsReadPopEvents } from './event-names';
import { TP_CREDIT_AGREEMENTS_READ_POP_MODULE } from './tianqi';

export default defineComponent({
  name: 'CreditAgreementsReadPop',
  components: {
    Popup,
    Button,
    UpArrowOutline12,
    DownArrowOutline12,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    commodityIdList: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  setup(
    props: CreditAgreementsReadPopProps,
    { emit }: { emit: (event: string, ...args: any[]) => void },
  ) {
    const activeIndex = ref<number>(0);
    // 协议列表(扁平化)
    const flatAgreementList = ref<Contract[]>([]);
    /** 当前加载的协议 */
    const currentLoadAgreement = ref<Contract | null>(null);
    /** 是否展开显示全部协议 */
    const expandShowAgreements = ref(false);

    // 处理弹窗显示状态更新
    const onUpdateShow = (value: boolean) => {
      emit(CreditAgreementsReadPopEvents.UPDATE_SHOW, value);
    };

    /** 处理关闭 */
    const onClose = () => {
      ubtSetupPageButton(TP_CREDIT_AGREEMENTS_READ_POP_MODULE, {
        buttonName: '关闭',
      });
      emit(CreditAgreementsReadPopEvents.CLOSE);
      onUpdateShow(false);
    };

    /** 处理确认 */
    const onConfirm = () => {
      ubtSetupPageButton(TP_CREDIT_AGREEMENTS_READ_POP_MODULE, {
        buttonName: '同意',
      });
      emit(CreditAgreementsReadPopEvents.AGREEMENT_CONFIRMED);
      onUpdateShow(false);
    };

    /** 请求渠道协议列表 */
    const getCommodityAgreementList = async () => {
      try {
        const commodityAgreementList = await getAgreementsByCommodities({
          commodityIds: props.commodityIdList || [],
          type: ContractEnum.PREAPPLY,
        });

        if (commodityAgreementList.length) {
          flatAgreementList.value = commodityAgreementList.reduce<Contract[]>(
            (acc, commodity) => acc.concat(commodity.contractList),
            [],
          );
        } else {
          throw new Error('commodityAgreementList-isEmpty');
        }
      } catch (error) {
        ubtSendError({
          name: 'getCommodityAgreementList-error',
          message: (error as Error)?.message,
        });
        onUpdateShow(false);
      }
    };
    const loadAgreementContent = (agreement?: Contract) => {
      let targetAgreement = agreement;

      if (!targetAgreement) {
        [targetAgreement] = flatAgreementList.value;
      }

      currentLoadAgreement.value = targetAgreement;
    };

    /** 处理协议点击 */
    const onAgreementClick = (agreement: Contract) => {
      activeIndex.value = flatAgreementList.value.indexOf(agreement);
      loadAgreementContent(agreement);
    };

    /** 初始化协议列表数据并定位到第一个协议 */
    watch(
      () => props.show,
      async (visible) => {
        if (visible) {
          await getCommodityAgreementList();

          ubtSetupModuleExpose(TP_CREDIT_AGREEMENTS_READ_POP_MODULE);

          loadAgreementContent();
        }
      },
      { immediate: true },
    );

    return {
      activeIndex,
      flatAgreementList,
      currentLoadAgreement,
      expandShowAgreements,
      onUpdateShow,
      onClose,
      onConfirm,
      onAgreementClick,
    };
  },
});
